import { useTranslation } from "react-i18next";
import { flattenSelection, selectionToNumericIds, useFilterContextV2 } from "../../../../contexts/FilterContextV2";
import { useDebugMode } from "../../../../contexts/DebugModeContext";

export function DebugSelectedAreaHectares() {
  const { t, i18n } = useTranslation();
  const { debugEnabled } = useDebugMode();
  const { selectedFarms, selectedAreas } = useFilterContextV2();
  if (!debugEnabled) return null;

  const farms = new Set(selectionToNumericIds(selectedFarms));
  const areas = Array.from(new Map(flattenSelection(selectedAreas)
    .filter(area => farms.size > 0 && (area.info?.farm?.id == null || farms.has(Number(area.info.farm.id))))
    .map(area => [String(area.value), area])).values());
  const hectares = areas.map(area => {
    const value = area.info?.acreage;
    if (value == null || value === "") return null;
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  });
  const total = areas.length > 0 && hectares.every(value => value !== null)
    ? hectares.reduce<number>((sum, value) => sum + (value ?? 0), 0) : null;
  const formatted = (value: number | null) => value === null ? t("reports.capacity.unavailable")
    : new Intl.NumberFormat(i18n.language, { maximumFractionDigits: 2 }).format(value);

  return (
    <section className="capacity-debug" aria-label={t("reports.capacity.debugHectares")}>
      <div className="capacity-debug__header">
        <h3 className="capacity-debug__title">{t("reports.capacity.debugHectares")}</h3>
        <span className="capacity-debug__total">{t("reports.capacity.debugTotalHectares", { hectares: formatted(total) })}</span>
      </div>
      {areas.length > 0 && <ul className="capacity-debug__areas">{areas.map((area, index) => (
        <li key={String(area.value)}>{t("reports.capacity.debugAreaHectares", {
          name: area.label, hectares: formatted(hectares[index]),
        })}</li>
      ))}</ul>}
    </section>
  );
}
